import { Directive, ElementRef, HostListener, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[plLowercaseInput]',
  standalone: false,
})
export class LowercaseInputDirective {
  constructor(
    private readonly _elementRef: ElementRef<HTMLInputElement>,
    @Optional() @Self() private readonly _ngControl: NgControl
  ) {}

  @HostListener('input')
  public onInput(): void {
    const input = this._elementRef.nativeElement;
    const lowercased = input.value.toLowerCase();

    if (input.value === lowercased) {
      return;
    }

    const { selectionStart, selectionEnd } = input;
    input.value = lowercased;
    input.setSelectionRange(selectionStart, selectionEnd);

    this._ngControl?.control?.setValue(lowercased, { emitEvent: false });
  }
}
